import React, { useEffect, useContext } from 'react'
import { Input } from '@mc/design-system'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { SHARE_OPTIONS } from '../constants'
import { trackShareExternallyClicked } from '../events'
import useClipboard from '../hooks/useClipboard'
import i18nInstance from '../i18n/i18nInstance'
import ShareContext from '../provider/ShareContext'

interface CopyLinkInputProps {
  link: string
  id: string | number
}

const CopyLinkInput = ({ link, id }: CopyLinkInputProps) => {
  const { t } = useTranslation('@mc/share')
  const shareData = useContext(ShareContext)
  const { copied, onCopy } = useClipboard()

  useEffect(() => {
    if (shareData === null) {
      return
    }

    if (copied) {
      trackShareExternallyClicked({
        channel: SHARE_OPTIONS.COPY,
        link,
        shareData,
      })
    }
  }, [copied, link, shareData])

  const CopyLink = (
    <button
      className='mc-text-h7 mc-text--capitalize mc-clickable mc-text-color--dark'
      onClick={() => onCopy(link)}
      data-testid='copy-button'
    >
      {copied ? t('copied') : t('copy')}
    </button>
  )

  return (
    <div className='d-flex'>
      <Input
        className='mc-form-element--disabled'
        value={link}
        readOnly
        append={CopyLink}
        data-testid='copy-input'
        id={id}
      />
    </div>
  )
}

export default withI18nContext(i18nInstance)(CopyLinkInput)
